import { HttpClient } from '@angular/common/http';
import { Component, inject, signal } from '@angular/core'

@Component({
    selector: 'app-testitsmeuserinfo',
    templateUrl: './testitsmeuserinfo.component.html',
    styleUrls: ['./testitsmeuserinfo.component.scss'],
})
export class TestItsMeUserInfoComponent {  
    userinfo = signal('Anonymous');
    private http = inject(HttpClient);
    
    ngOnInit(): void {
          this.http.get(`api/itsme/login/userinfo`).subscribe((response) => {
            var json = JSON.stringify(response,null,2);
            this.userinfo.set(json);
        })
    }    
}